module.exports = __webpack_public_path__ + "static/mentor-vidushi-9f2604c2e4996d9cbd09046340dad44f.jpg";